import getCommonData from '~/lib/tealium/data/common-data';
import getPageData from '~/lib/tealium/data/page-data';
import getEventData from '~/lib/tealium/data/event-data';

const getPageTag = lang => {
  return {
    description: 'Fired on each page load.',
    // useful property to identify if event is view or link
    isViewEvent: true,
    eventIdentifier: {
      type: 'mounted',
      component: 'component',
    },
    // eslint-disable-next-line no-unused-vars
    content: (piggyEvent, wizardValues) => {
      return {
        ...getCommonData(lang),
        ...getPageData(piggyEvent.trackingPageName),
        ...getEventData(piggyEvent.trackingPageName),
      };
    },
  };
};

export default getPageTag;
